import { CheveronDownIcon } from '@wkda/icons';
import cx from 'classnames';
import { useState, type ReactNode } from 'react';
import type { PaperProps } from '../Paper/index.js';
import Paper from '../Paper/index.js';
import { ItemTitle } from '../VerticalNavMenu/index.js';
import type { Dropdown } from '../shared.types.js';

export interface NavMenuProps extends PaperProps {
  LinkComponent?: any;
  dropdowns: Dropdown[];
}

export default function NavMenu({
  dropdowns,
  LinkComponent = 'a',
  className,
  title: _title = '',
  ...spreadProps
}: NavMenuProps) {
  const [openedIndexes, setOpenedIndexes] = useState<number | null>(null);

  function toggleDropDown(itemIndex: number): void {
    setOpenedIndexes((prevIndex) => {
      if (prevIndex === itemIndex) {
        return null;
      }
      return itemIndex;
    });
  }
  const lastDropDownItem = dropdowns[dropdowns.length - 1];
  return (
    <>
      <Paper
        isElevated
        isFixedTop
        className={cx('wa-nav', className)}
        {...spreadProps}
      >
        {dropdowns.map(function (dropDown, index) {
          return (
            <NavListItems
              key={index}
              title={dropDown.title !== '' ? <ItemTitle {...dropDown} /> : null}
              items={dropDown.items}
              LinkComponent={LinkComponent}
              isOpened={openedIndexes === index}
              onTitleClick={() => {
                toggleDropDown(index);
              }}
            />
          );
        })}
      </Paper>
      {lastDropDownItem?.id === 'invisible' && (
        <div style={{ height: '40px' }} />
      )}
    </>
  );
}

export interface NavListItemsProps extends Omit<Dropdown, 'title'> {
  title: ReactNode | string;
  LinkComponent: any;
  isOpened: boolean;
  onTitleClick: () => void;
}

function NavListItems({
  title,
  mobileTitle,
  items,
  LinkComponent,
  isOpened,
  onTitleClick,
}: NavListItemsProps) {
  const listTitle = title ? (
    <ItemTitle title={title} mobileTitle={mobileTitle} />
  ) : null;

  return (
    <ul className="wa-nav__list">
      {listTitle && (
        <li
          className={cx('wa-nav__list-item', {
            'wa-nav__list-item--open': isOpened,
          })}
        >
          <button
            className="wa-nav__list-item-link"
            onClick={() => onTitleClick()}
          >
            {listTitle}
            <CheveronDownIcon
              className={cx('wa-nav__chevron', {
                'wa-nav__chevron--is-open': isOpened,
              })}
            />
          </button>
        </li>
      )}
      {/*if title exist, open the list on click otherwise it show them*/}
      {(!listTitle || isOpened) &&
        items.map((item, key) => (
          <li className="wa-nav__list-item" key={key}>
            <LinkComponent
              className="wa-nav__list-item-link wa-nav__list-item-link--sub"
              href={item.link}
            >
              <ItemTitle {...item} />
            </LinkComponent>
          </li>
        ))}
    </ul>
  );
}
